import {Action, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import {Inject} from 'inversify-props';

import {ILoraHardwareService} from '@/services/lora/ILoraHardware.service';
import {AntennaType} from '@/model/lora/AntennaType';

@Module({name: 'LoraHardwareStore', namespaced: true})
export default class LoraHardwareStore extends VuexModule {
  protected region: string | null = null;
  protected availableRegions: string[] | null = null;
  protected antenna: AntennaType | null = null;

  protected antennaTypes: AntennaType[] = [
    new AntennaType('2dbi', '2dBi gain'),
    new AntennaType('3dbi', '3dBi gain'),
    new AntennaType('4dbi', '4dBi gain'),
    new AntennaType('5dbi', '5dBi gain'),
  ];

  @Inject(Symbol.for('ILoraHardwareService'))
  private loraHardwareService!: ILoraHardwareService;

  /* REGION */
  @Action({commit: 'setRegion', rawError: true})
  public async fetchRegion() {
    return await this.loraHardwareService.getRegion();
  }

  @Mutation
  public setRegion(region: string) {
    this.region = region;
  }

  get Region(): string | null {
    return this.region;
  }

  /* AVAILABLE REGIONS */
  @Action({commit: 'setAvailableRegions', rawError: true})
  public async fetchAvailableRegions() {
    return await this.loraHardwareService.getAvailableRegions();
  }

  @Mutation
  public setAvailableRegions(regions: string[]) {
    this.availableRegions = regions;
  }

  get AvailableRegions(): string[] | null {
    return this.availableRegions;
  }

  /* ANTENNA */
  @Action({commit: 'setAntenna', rawError: true})
  public async fetchAntenna() {
    const antennaType = await this.loraHardwareService.getAntennaType();
    return this.antennaTypes.find((a) => a.Id === antennaType) ?? new AntennaType('unknown', 'Unknown');
  }

  @Mutation
  public setAntenna(antennaType: AntennaType | null) {
    this.antenna = antennaType;
  }

  get Antenna(): AntennaType | null {
    return this.antenna;
  }

  get AntennaTypes(): AntennaType[] {
    return this.antennaTypes;
  }
}
